import {MidiDeviceCategory, MidiDeviceDirection} from "./Midi";

export {MidiDeviceHolder}

class MidiDeviceHolder {

    readonly output: WebMidi.MIDIOutput | null;
    readonly input: WebMidi.MIDIInput | null;
    readonly category: MidiDeviceCategory;
    readonly direction: MidiDeviceDirection | null;
    readonly name: string | undefined;
    readonly id: string;
    constructor(device: WebMidi.MIDIOutput | WebMidi.MIDIInput,
                category: MidiDeviceCategory) {
        this.input = null;
        this.output = null;
        this.direction = null;
        this.id = device.id;
        this.name = device.name;
        if ('send' in device) {
            this.output = device as WebMidi.MIDIOutput;
            this.direction = MidiDeviceDirection.Output;
        }
        if ('onmidimessage' in device) {
            this.input = device as WebMidi.MIDIInput;
            this.direction = MidiDeviceDirection.Input;
        }
        this.category = category;
    }

    setOnMidiMessage(callback: (message: WebMidi.MIDIMessageEvent) => void) {
        if (this.input !== null) {
            this.input.onmidimessage = callback;
        }
    }

    send(data : Uint8Array) {
        if (this.output !== null) {
            this.output.send(data);
        }
    }
}